exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-chart-legend{display:block;width:100%}adp-chart-legend ul{flex-direction:column;align-items:center;justify-content:space-around}adp-chart-legend li{width:100%;padding-top:15px;padding-bottom:15px;border-bottom:1px solid #d8d8d8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpChartLegend/adpChartLegend.less
// module id = 624
// module chunks = 0